import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import {
  ImageSettings,
  RichTextWrapperComponent,
} from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import type { ButtonTheme, ContentTheme } from '@legacy/common-ui-partials';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  ButtonComponent,
  MediaSectionComponent,
  ImageComponent,
  StructuredContentComponent,
} from '@legacy/common-ui-partials';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

import {
  BasicContentValues,
  BasicContentSettings,
} from '../../basic-content-settings.model';

@Component({
  selector: 'wl-basic-content-variant-media-section',
  templateUrl: './basic-content-variant-media-section.component.html',
  styleUrls: [
    './basic-content-variant-media-section.ed.scss',
    './basic-content-variant-media-section.essent.scss',
  ],
  standalone: true,
  imports: [
    MediaSectionComponent,
    ImageComponent,
    StructuredContentComponent,
    FaIconComponent,
    JssModule,
    RichTextWrapperComponent,
    ButtonComponent,
    NgClass,
    TrackLinkDirective,
  ],
})
export class BasicContentVariantMediaSectionComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() content?: BasicContentValues;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() settings?: BasicContentSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() image?: ImageSettings;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  primaryButtonTheme: ButtonTheme = 'secondary';

  get contentTheme(): ContentTheme | undefined {
    // This breaks super easily, should match something like 'settings.theme'.
    // The idea is to set an override so cards with a transparent background
    // on a dark row automatically get a brand-alt theme for the content.
    if (
      this.context?.backgroundClass === 'bg-brand-alt' &&
      this.settings?.theme === 'translucent'
    ) {
      return 'brand-alt';
    }
    return this.settings?.theme;
  }

  get reserveVerticalSpacing() {
    return this.settings?.theme !== 'translucent';
  }

  private setPrimaryButtonTheme() {
    const buttonStyleString = this.content?.buttons?.primary?.style;
    const style = buttonStyleString?.includes('primary')
      ? 'primary'
      : 'secondary';
    this.primaryButtonTheme = style;
  }

  ngOnInit() {
    this.setPrimaryButtonTheme();
  }
}
